<p-accordionTab (selectedChange)="togglePanel($event)" [disabled]="configured !== 0">
	<ng-template pTemplate="header">
		<div class="grid flex align-items-center w-full -mb-3">
			<div [class]="!onExtendedMobile() ? 'col-10' : 'col-12 flex justify-content-center'" class="py-0">
				<span class="font-semibold white-space-nowrap">{{ 'SETTINGS' | translate }}</span>
			</div>
			<div
				[class]="!onExtendedMobile() ? 'col-2 flex align-items-center justify-content-end' : 'col-12 flex align-items-center justify-content-center'"
				class="py-0">
				<p-button *ngIf="online" pTooltip="{{ 'RELOAD' | translate }}" tooltipPosition="bottom" icon="pi cm-reload"
					size="large" (click)="$event.stopPropagation(); loadSettings()" [rounded]="false" [text]="true"
					severity="primary">
				</p-button>
			</div>
		</div>
	</ng-template>
	<div>
		<div *ngIf="passwordSupport && !passwordVerify && online && (isTechnician || isImpersMode)">
			<div class="col-12 flex align-items-center justify-content-center bg-red-200 p-1 border-round-xl">
				<p-tag icon="pi cm-alert" [value]="('PASSWORD_REQUEST_OR_ERR_CON' | translate)" severity="danger"></p-tag>
			</div>
		</div>
		<div *ngIf="loading && online">
			<div class="flex align-items-center justify-content-center w-full">
				<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
			</div>
		</div>
		<div class="grid" *ngIf="!online">
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
				<p-tag icon="pi cm-alert" [value]="('OFFLINE_ALERT' | translate)" severity="warning"></p-tag>
			</div>
		</div>
		<div *ngIf="!loading && isAccess()">
			<form (ngSubmit)="submit()" *ngIf="settingsForm" [formGroup]="settingsForm">
				<p-accordion>
					<div *ngFor="let settingCategory of settingsCategories; let i=index;">
						<p-accordionTab *ngIf="!isCustomCategoryRbe(settingCategory) && !isNull(settingCategory)">
							<ng-template pTemplate="header">
								<div class="flex align-items-center justify-content-between w-full -my-3">
									<span class="font-semibold">{{ settingCategory.Description }}</span>
								</div>
							</ng-template>
							<div>
								<div *ngFor="let setting of settingCategory.Settings; let i=index;">
									<div *ngIf="setting.Value !== null"
										[class]="underTablet() ? 'grid mt-1' : 'col-12 flex align-items-center justify-content-between'">
										<ng-container>
											<div *ngIf="setting.ControlItem.Type === 'slider'"
												[class]="underTablet() ? 'col-12 flex align-items-center justify-content-center text-center' : 'col-6 flex align-items-center justify-content-start text-start' ">
												{{ setting.Description }}</div>
											<div *ngIf="setting.ControlItem.Type === 'slider'"
												[class]="underTablet() ? 'col-12' : 'col-6 pl-0 py-1' "
												class="flex align-items-center justify-content-center">
												<div class="flex align-items-center justify-content-center w-full">
													<p-button pTooltip="{{ 'DECREASE' | translate }}"
														[disabled]="isSliderMin(setting)" tooltipPosition="bottom" icon="pi cm-minus"
														size="large" (click)="setSliderValue(setting, -1)" [rounded]="false"
														[text]="true" severity="primary" class="pr-3">
													</p-button>
													<div>{{formattedSliderMin(setting)}}</div>

													<div class="flex flex-column w-full mx-4">
														<!-- !! TO CHECK IF VARIANT=FILLED IS OK (punto al posto della virgola)-->
														<p-inputNumber mode="decimal" [useGrouping]="false" variant="filled"
															[formControlName]="setting.Id" class="flex w-full" styleClass="flex w-full"
															[min]="getSliderScaledMin(setting)" [max]="getSliderScaledMax(setting)"
															(onBlur)="onChangeInputSlider(setting)">
														</p-inputNumber>
														<p-slider [formControlName]="setting.Id" class="w-full"
															[step]="getSliderScaledStep(setting)" [min]="getSliderScaledMin(setting)"
															[max]="getSliderScaledMax(setting)" (onChange)="onChangeSlider(setting)">
														</p-slider>
													</div>

													<div>{{ formattedSliderMax(setting) }}</div>
													<p-button pTooltip="{{ 'INCREASE' | translate}}"
														[disabled]="isSliderMax(setting)" tooltipPosition="bottom" icon="pi cm-plus"
														size="large" (click)="setSliderValue(setting, 1)" [rounded]="false"
														[text]="true" severity="primary" class="pl-3">
													</p-button>
												</div>
											</div>
											<!-- !! TO CHECK LAYOUT AND FEATURE -->
											<div *ngIf="setting.ControlItem.Type === 'numeric'">
												<div class="flex justify-content-between flex-wrap">
													<div class="flex align-items-center justify-content-center">{{
														setting.Description }} *</div>
													<div class="flex align-items-center justify-content-center">
														<p-inputNumber [formControlName]="setting.Id" step="1" [useGrouping]="false"
															[maxFractionDigits]="0" [showButtons]="true" incrementButtonClass="p-0"
															decrementButtonClass="p-0 border-noround" [max]="setting.ControlItem.Max"
															[min]="setting.ControlItem.Min">
														</p-inputNumber>
													</div>
												</div>
											</div>
											<div *ngIf="setting.ControlItem.Type === 'combo'" class="col-12 pb-0">
												<div class="flex justify-content-between flex-wrap"
													[ngClass]="dynamicBorderLabelMobile('borderRow')">
													<div class="flex align-items-center justify-content-center"
														[ngClass]="dynamicBorderLabelMobile('label')">{{ setting.Description }}</div>
													<div class="flex align-items-center justify-content-center"
														[ngClass]="dynamicBorderLabelMobile('borderInput')">
														<p-dropdown [options]="setting.ControlItem.Items"
															[ngClass]="dynamicInputTextWidth()"
															styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
															[formControlName]="setting.Id">
															<ng-template pTemplate="selectedItem">
																<div class="item"
																	class="flex align-items-center justify-content-center text-center pl-5">
																	<div class="flex align-items-center">{{ (f[setting.Id]) ?
																		f[setting.Id].value.Description : "" }}</div>
																</div>
															</ng-template>
															<ng-template let-controlItem pTemplate="item">
																<div class="item">
																	<div>{{ controlItem.Description }}</div>
																</div>
															</ng-template>
														</p-dropdown>
													</div>
												</div>
												<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
												<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
											</div>
											<div *ngIf="setting.ControlItem.Type === 'color_picker'" class="col-12 pb-0">
												<div class="flex justify-content-between flex-wrap"
													[ngClass]="dynamicBorderLabelMobile('borderRow')">
													<div class="flex align-items-center justify-content-center"
														[ngClass]="dynamicBorderLabelMobile('label')">{{ setting.Description }}</div>
													<div class="flex align-items-center justify-content-center"
														[ngClass]="dynamicBorderLabelMobile('borderInput')">
														<p-dropdown [options]="setting.ControlItem.Items"
															[ngClass]="dynamicInputTextWidth()"
															styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
															[formControlName]="setting.Id">
															<ng-template pTemplate="selectedItem">
																<div class="flex align-items-center justify-content-center">
																	<div
																		class="w-1_5rem h-1_5rem flex-shrink-0 border-circle cursor-pointer surface-border transition-all transition-duration-300 mr-3"
																		style="border: 1px solid;"
																		[ngStyle]="{'color': getColorSettingValue(f[setting.Id].value), 'background-color': getColorSettingValue(f[setting.Id].value)}">
																	</div>
																	<div>{{ (f[setting.Id]) ? f[setting.Id].value.Description : "" }}
																	</div>
																</div>
															</ng-template>
															<ng-template let-controlItem pTemplate="item">
																<div class="item flex align-items-center justify-content-center">
																	<div
																		class="w-1_5rem h-1_5rem flex-shrink-0 border-circle surface-border cursor-pointer transition-all transition-duration-300 mr-3"
																		style="border: 1px solid;"
																		[ngStyle]="{'color': getColorSettingValue(controlItem), 'background-color': getColorSettingValue(controlItem)}">
																	</div>
																	<div>{{ controlItem.Description }}</div>
																</div>
															</ng-template>
														</p-dropdown>
													</div>
												</div>
											</div>
										</ng-container>
									</div>
								</div>
							</div>
						</p-accordionTab>
					</div>
					<div *ngIf="isRbe()"> <!-- ONLY RBE 24/230 CUSTOM-->
						<div *ngFor="let settingCategory of customSettingsCategories" class="section">
							<p-accordionTab>
								<ng-template pTemplate="header">
									<div class="flex align-items-center justify-content-between w-full -my-3">
										<div class="font-semibold">{{ settingCategory.Description }}</div>
										<p-button icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}"
											*ngIf="settingCategory.Category === 'outputs'" tooltipPosition="bottom"
											(click)="$event.stopPropagation(); editAliasOutput()" [text]="true"
											severity="secondary">
										</p-button>
										<p-button icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}"
											*ngIf="settingCategory.Category === 'inputs'" tooltipPosition="bottom"
											(click)="$event.stopPropagation(); editAliasInput()" [text]="true"
											severity="secondary">
										</p-button>
										<p-button icon="pi cm-pencil" pTooltip="{{ 'EDIT' | translate }}"
											*ngIf="settingCategory.Category === 'bus_selectors'" tooltipPosition="bottom"
											(click)="$event.stopPropagation(); editAliasSelector()" [text]="true"
											severity="secondary">
										</p-button>
									</div>
								</ng-template>
								<p-panel *ngFor="let group of settingCategory.CustomSettings | keyvalue: asisorder"
									styleClass="p-panel-allWhite mb-3">
									<ng-template pTemplate="header">
										<div class="flex align-items-center justify-content-center w-full">
											<span class="font-semibold" *ngIf="settingCategory.Category === 'outputs'">{{ ('OUTPUT'
												| translate) + group.key + getOutputName(group.key)}}</span>
											<span class="font-semibold" *ngIf="settingCategory.Category === 'bus_selectors'">{{
												('SELECTOR' | translate) + group.key + getSelectorName(group.key)}}</span>
											<span class="font-semibold" *ngIf="settingCategory.Category === 'inputs'">{{ ('INPUT' |
												translate) + ' ' + group.key + getInputName(group.key) }}</span>
										</div>
									</ng-template>
									<div *ngFor="let setting of group.value; let i=index;">
										<div
											[class]="underTablet() ? 'grid mt-1' : 'col-12 flex align-items-center justify-content-between px-0 pt-0 pb-5' ">
											<ng-container>
												<div *ngIf="setting.ControlItem.Type === 'slider'"
													[class]="underTablet() ? 'col-12 flex align-items-center justify-content-center text-center' : 'col-6 flex align-items-center justify-content-start text-start' ">
													{{ setting.Description }}</div>
												<div *ngIf="setting.ControlItem.Type === 'slider'"
													[class]="underTablet() ? 'col-12' : 'col-6 pl-0 py-1' "
													class="flex align-items-center justify-content-center">
													<div class="flex align-items-center justify-content-center w-full">
														<p-button pTooltip="{{ 'DECREASE' | translate }}"
															[disabled]="isSliderMin(setting)" tooltipPosition="bottom"
															icon="pi cm-minus" size="large" (click)="setSliderValue(setting, -1)"
															[rounded]="false" [text]="true" severity="primary" class="pr-3">
														</p-button>
														<div>{{formattedSliderMin(setting)}}</div>

														<div class="flex flex-column w-full mx-4">
															<!-- !! TO CHECK IF VARIANT=FILLED IS OK (punto al posto della virgola)-->
															<p-inputNumber mode="decimal" [useGrouping]="false" variant="filled"
																[formControlName]="setting.Id" class="flex w-full"
																styleClass="flex w-full" [min]="getSliderScaledMin(setting)"
																[max]="getSliderScaledMax(setting)"
																(onBlur)="onChangeInputSlider(setting)">
															</p-inputNumber>
															<p-slider [formControlName]="setting.Id" class="w-full"
																[step]="getSliderScaledStep(setting)"
																[min]="getSliderScaledMin(setting)" [max]="getSliderScaledMax(setting)"
																(onChange)="onChangeSlider(setting)">
															</p-slider>
														</div>

														<div>{{ formattedSliderMax(setting) }}</div>
														<p-button pTooltip="{{ 'INCREASE' | translate}}"
															[disabled]="isSliderMax(setting)" tooltipPosition="bottom"
															icon="pi cm-plus" size="large" (click)="setSliderValue(setting, 1)"
															[rounded]="false" [text]="true" severity="primary" class="pl-3">
														</p-button>
														<!--OLD-->
														<!--<p-button pTooltip="{{ 'DECREASE' | translate }}"
																[disabled]="isSliderMin(setting)"
																tooltipPosition="bottom" icon="pi cm-minus" size="large"
																(click)="setSliderValue(setting, -1)" [rounded]="false" [text]="true" severity="primary"
																class="pr-3">
														</p-button>
														<div>{{formattedSliderMin(setting)}}</div>

														<div class="flex flex-column w-full mx-4">
															<p-inputNumber mode="decimal"  [useGrouping]="false"
																	[formControlName]="setting.Id"
																	class="flex w-full"
																	styleClass="flex w-full"
																	[min]="getSliderScaledMin(setting)"
																	[max]="getSliderScaledMax(setting)">
															</p-inputNumber>
															<p-slider [formControlName]="setting.Id" class="w-full" [step]="getSliderScaledStep(setting)"
																	[min]="getSliderScaledMin(setting)"
																	[max]="getSliderScaledMax(setting)">
															</p-slider>
														</div>
															
														<div>{{ formattedSliderMax(setting) }}</div>
														<p-button pTooltip="{{ 'INCREASE' | translate}}"
																	[disabled]="isSliderMax(setting)"
																	tooltipPosition="bottom" icon="pi cm-plus" size="large"
																	(click)="setSliderValue(setting, 1)" [rounded]="false" [text]="true" severity="primary"
																	class="pl-3">
														</p-button>-->
													</div>
												</div>
												<!-- !! TO CHECK LAYOUT AND FEATURE -->
												<div *ngIf="setting.ControlItem.Type === 'numeric'">
													<div class="flex justify-content-between flex-wrap">
														<div class="flex align-items-center justify-content-center">{{
															setting.Description }}</div>
														<div class="flex align-items-center justify-content-center">
															<p-inputNumber [formControlName]="setting.Id" step="1"
																[useGrouping]="false" [maxFractionDigits]="0" [showButtons]="true"
																incrementButtonClass="p-0" decrementButtonClass="p-0 border-noround"
																[max]="setting.ControlItem.Max" [min]="setting.ControlItem.Min">
															</p-inputNumber>
														</div>
													</div>
												</div>
												<div *ngIf="setting.ControlItem.Type === 'combo'" class="col-12 pb-0">
													<!-- <div class="flex justify-content-between flex-wrap" [ngClass]="showErrors(this.f.category, 'borderRow')">
															<div class="flex align-items-center justify-content-center" [ngClass]="showErrors(this.f.category, 'label')">{{ setting.Description }}</div>
															<div class="flex align-items-center justify-content-center" [ngClass]="showErrors(this.f.category,'borderInput')"> -->
													<div class="flex justify-content-between flex-wrap"
														[ngClass]="dynamicBorderLabelMobile('borderRow')">
														<div class="flex align-items-center justify-content-center"
															[ngClass]="dynamicBorderLabelMobile('label')">{{ setting.Description }}
														</div>
														<div class="flex align-items-center justify-content-center"
															[ngClass]="dynamicBorderLabelMobile('borderInput')">
															<p-dropdown [options]="setting.ControlItem.Items"
																[ngClass]="dynamicInputTextWidth()" appendTo="body"
																styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
																[formControlName]="setting.Id">
																<ng-template pTemplate="selectedItem">
																	<div class="item"
																		class="flex align-items-center justify-content-center text-center pl-5">
																		<div class="flex align-items-center">{{ (f[setting.Id]) ?
																			f[setting.Id].value.Description : "" }}</div>
																	</div>
																</ng-template>
																<ng-template let-controlItem pTemplate="item">
																	<div class="item">
																		<div>{{ controlItem.Description }}</div>
																	</div>
																</ng-template>
															</p-dropdown>
														</div>
													</div>
													<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
													<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
												</div>
												<!-- !! TO CHECK LAYOUT AND FEATURE -->
												<div *ngIf="setting.ControlItem.Type === 'bitmask'" class="w-full">
													<div class="col-12">
														<div class="flex justify-content-between flex-wrap"
															[ngClass]="dynamicBorderLabelMobile('borderRow')">
															<div class="flex align-items-center justify-content-center"
																[ngClass]="dynamicBorderLabelMobile('label')">{{ setting.Description }}
															</div>
															<div class="flex align-items-center justify-content-center"
																[ngClass]="dynamicBorderLabelMobile('borderInput')">
																<div *ngFor="let item of setting.ControlItem.Items">
																	<p-checkbox [formControlName]="setting.Id+'_b_'+item.Value"
																		[binary]="true"
																		pTooltip="{{ getOutputNameSelector(setting, item)}}"
																		label="{{ item.Description }}" class="ml-4 mb-2 md:mb-0">
																	</p-checkbox>
																</div>
															</div>
														</div>
													</div>
												</div>
											</ng-container>
										</div>
									</div>
								</p-panel>
							</p-accordionTab>
						</div>
					</div>
					<button type="submit" pButton pRipple [loading]="saving" [disabled]="!settingsForm.dirty || saving"
						label="{{ 'SAVE' | translate }}" class="p-button-primary text-xl font-normal mt-3">
					</button>
				</p-accordion>
			</form>
		</div>
	</div>
</p-accordionTab>